<template>
  <div class="font-sans antialiased text-gray-900">
    <slot />
  </div>
</template>
